// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap___oXtF","actionsCol":"EnrolledClinics_actionsCol__foNrf"};